import { useQuery } from "@tanstack/react-query";

import { DefaultFetchService } from "app/services/fetchService";

export interface IKeywordGroup {
    Id: string;
    Name: string;
    Keywords: string[];
}

interface IKeywordGroupsResponse {
    OwnerGroups: IKeywordGroup[];
    SharedGroups: IKeywordGroup[];
}

interface IUseKeywordGroupsReturn {
    data?: IKeywordGroupsResponse;
    userGroups: IKeywordGroup[];
    sharedGroups: IKeywordGroup[];
    allGroups: IKeywordGroup[];
    isLoading: boolean;
    error: Error | null;
}

const fetchService = DefaultFetchService.getInstance();

const fetchKeywordGroups = async (): Promise<IKeywordGroupsResponse> => {
    return await fetchService.get<IKeywordGroupsResponse>("/api/userdata/KeywordGroups", undefined, {
        preventAutoCancellation: true,
    });
};

export const useKeywordGroups = (): IUseKeywordGroupsReturn => {
    const query = useQuery({
        queryKey: ["keywordGroups"],
        queryFn: fetchKeywordGroups,
        staleTime: 30 * 60 * 1000, // 30 minutes
        gcTime: 30 * 60 * 1000, // 30 minutes
        retry: 1,
    });

    const userGroups = query.data?.OwnerGroups || [];
    const sharedGroups = query.data?.SharedGroups || [];
    const allGroups = [...userGroups, ...sharedGroups];

    return {
        data: query.data,
        userGroups,
        sharedGroups,
        allGroups,
        isLoading: query.isLoading,
        error: query.error,
    };
};